// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list[data-v-685d3452] .v-list-item__subtitle,.v-list[data-v-685d3452] .v-list-item__title{white-space:normal!important}.noLink[data-v-685d3452]{text-decoration:none!important;color:#000!important;line-height:49px;display:inline-block}", ""]);
// Exports
module.exports = exports;
